// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2KNFt","containerItemsCenter":"Skeleton_containerItemsCenter__3nJba"};